// src/pages/Research.js
import React, { useState } from 'react';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

export default function Research() {
  const [q, setQ] = useState('');
  const [note, setNote] = useState('');
  const [msg, setMsg] = useState('');
  const db = getFirestore();
  const auth = getAuth();

  const submit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user) { setMsg('You must be signed in.'); return; }
    try {
      await addDoc(collection(db, 'searchLogs'), {
        uid: user.uid,
        email: user.email || null,
        query: q.trim(),
        note: note.trim() || null,
        createdAt: serverTimestamp(),
        scope: 'internal',     // hint for reviewers
        export: 'prohibited',  // hint for reviewers
      });
      setQ(''); setNote('');
      setMsg('Logged ✔ — a supervisor/analyst can follow up.');
    } catch (err) {
      setMsg('Log failed: ' + (err?.message || String(err)));
    }
  };

  return (
    <div style={{ padding: 16, maxWidth: 720 }}>
      <h2>Research (Authorized)</h2>
      <p style={{ color: '#6b7280' }}>
        Operational continuity only. All searches are logged and visible to supervisors.
        External export is prohibited. Sensitive PII is masked unless role permits.
      </p>

      <form onSubmit={submit} style={{ display: 'grid', gap: 8, marginTop: 12 }}>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search intent (e.g., 'related incidents at 123 Main…')"
          style={{ padding: 8, border: '1px solid #e5e7eb', borderRadius: 8 }}
          required
        />
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Optional note / case # / reason"
          rows={3}
          style={{ padding: 8, border: '1px solid #e5e7eb', borderRadius: 8 }}
        />
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button type="submit" style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #e5e7eb' }}>
            Log Search
          </button>
          {msg && <span style={{ color: '#2563eb' }}>{msg}</span>}
        </div>
      </form>
    </div>
  );
}
